import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../../Utils/withRouter";
import axios from "axios";
import { formatDate, } from "../../../Components/InputElements";
import Swal from "sweetalert2";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NoRecords } from '../../../Components/Shimmer';
import { currentDateAndTime, parseQueryString, genderOptions } from '../../../Constants/constants';



const emergencyContactPerson = [
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Son', label: 'Son' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Husband', label: 'Husband' },
  { value: 'Wife', label: 'Wife' },
  { value: 'Uncle', label: 'Uncle' },
  { value: 'Aunt', label: 'Aunt' },
  { value: 'Nephew', label: 'Nephew' },
  { value: 'Niece', label: 'Niece' },
  { value: 'Grandfather', label: 'Grandfather' },
  { value: 'Grandmother', label: 'Grandmother' },
  { value: 'Grandson', label: 'Grandson' },
  { value: 'Granddaughter', label: 'Granddaughter' },
  { value: 'Cousin', label: 'Cousin' },
  { value: 'Father-in-law', label: 'Father-in-law' },
  { value: 'Mother-in-law', label: 'Mother-in-law' },
  { value: 'Brother-in-law', label: 'Brother-in-law' },
  { value: 'Sister-in-law', label: 'Sister-in-law' },
  { value: 'Stepfather', label: 'Stepfather' },
  { value: 'Stepmother', label: 'Stepmother' },
  { value: 'Stepbrother', label: 'Stepbrother' },
  { value: 'Stepsister', label: 'Stepsister' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Guardian', label: 'Guardian' },
  { value: 'Other', label: 'Other' },
];

class FamilyDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_degree: '',
      employee_family_id: '',
      institute_university: '',
      year_of_passout: '',
      percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSubmit: false,
      keyword: "",
      from_date: "",
      to_date: "",
      family_Member_Name: '',
      relation: 'No',
      emergency_Contact_Person: 'Brother',
      is_Dependend: 'No',
      date_Of_Birth: '',
      gender: 'Male',
      mobile_Number: '',
      add_family_member: '',
      errors: {},
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    if (encryptedData) {
      this.setState({ 
        loadingList:true,
            encryptedData:encryptedData,
            guest_employee_mobile_number: "",
            company_id: "",
       }, (prevState) => {
        this.getDecryptedData();
      });
    } else if (!encryptedData) {
      this.setState({
        encryptedData:'',
        guest_employee_mobile_number: "",
        company_id: "",
      });
    }
  }




  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({loadingSubmit:true});
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const formData = {
      employee_family_detail:[{
        employee_family_id: this.state.employee_family_id || null,
        family_member_name: this.state.family_Member_Name,
        relation: this.state.relation,
        family_member_relation: this.state.emergency_Contact_Person,
        family_member_dependent: this.state.is_Dependend,
        family_member_dob: this.state.date_Of_Birth,
        family_member_gender: this.state.gender,
        family_member_contact_number: this.state.mobile_Number,
      },],

    }
    axios.post(`${apiURL}Home/CreateUpdateEmployeeFamilyDetails`, formData, {
      params:{
        date: currentDateAndTime(),
        company_id: this.state.company_id,
        guest_employee_mobile_number: this.state.guest_employee_mobile_number,
      },
       headers })
      .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          employee_family_id:"",
          family_Member_Name: '',
          relation: 'No',
          emergency_Contact_Person: 'Brother',
          is_Dependend: 'No',
          date_Of_Birth: '',
          gender: 'Male',
          mobile_Number: '',
          add_family_member: false,
        });
        // this.closeRef.current.click();
        this.setState({ loadingList: true, loadingSubmit:false, add_family_member:false }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        })
      }
    }).catch((error)=>{
          Swal.fire({
            title: `<strong>Failed</strong>`,
            text: 'Opps...! Something went wrong.',
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick:false
          })
          
        }).finally(this.setState({ loadingList: false, loadingSubmit:false }))
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Home/EmployeeCollectedData`, {
        params: {
          company_id: this.state.company_id,
          guest_employee_mobile_number:this.state.guest_employee_mobile_number,
          date: currentDateAndTime(),
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            
            rows: data?.employee_family_detail,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSubmit:false,
          });
        } else {
          this.setState({ loadingList: false,loadingSubmit:false, });
        }
      });
  };
  getDecryptedData = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const fromData={
        encryptedData:this.state.encryptedData
    }
    axios
        .post(`${apiURL}User/DecryptData`,fromData, {headers})
        .then((response) => {
            var data = response.data;
            console.log('DecryptData',data);
            if (response.data.success === true) {
                let temp= parseQueryString(data?.decryptedData);
                console.log("tenp",temp);
                this.setState({
                  company_id:temp?.c_id,
                  guest_employee_mobile_number:temp?.mo_n,
                },()=>{
                  this.GetList();
                });
            } else {
              this.setState({
        
                loadingList: false,
              });
            }
        }).catch((error)=>{
          this.setState({
            loadingList: false,
          });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong !!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        });
};
  handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleEdit = (row)=>{
    this.setState({
      employee_family_id: row?.employee_family_id,
      family_Member_Name: row?.family_member_name,
      // relation: row?.family_member_relation,
      emergency_Contact_Person: 'Brother',
      is_Dependend: row?.family_member_dependent,
      date_Of_Birth: row?.family_member_dob,
      gender: row?.family_member_gender,
      mobile_Number: row?.family_member_contact_number,
      add_family_member:true,
    });
  }

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_family_id: id,
        };
        axios
          .post(`${apiURL}Home/DeleteFamilyDetails`, formData, {
            params:{
              company_id: this.state.company_id,
          guest_employee_mobile_number:this.state.guest_employee_mobile_number,
          date: currentDateAndTime(),
            },
             headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    const mobileRegex = /^[0-9]{10}$/;

    if (!this.state.family_Member_Name) errors.family_Member_Name = 'Family  Member Name is required';
    if (!this.state.emergency_Contact_Person) errors.emergency_Contact_Person = 'Relation is required';
    if (!this.state.is_Dependend) errors.is_Dependend = 'Dependend Field is required';
    if (!this.state.date_Of_Birth){
      errors.date_Of_Birth = 'Date Of Birth is required';
    } 
    if (this.state.date_Of_Birth){
      const dob= this.state.date_Of_Birth;
      console.log("DOB =>",dob);
      const year = dob.split("-")[0];
      if (!/^\d{4}$/.test(year)) {
        errors.date_Of_Birth = "Year must be a 4-digit number.";
      }
      else if (dob > currentDateAndTime()) {
        errors.date_Of_Birth = "Date of birth cannot be in the future." ;
      }
      // errors.date_Of_Birth = 'Date Of Birth is required';
    } 
    if (!this.state.gender) errors.gender = 'Family Member Gender is required';
    if (!this.state.mobile_Number){
    
      errors.mobile_Number = 'Family Member Mobile number is required';
    } 
    if (this.state.mobile_Number){
      const mob=`${this.state.mobile_Number}`;
      if(mob?.length<10 || mob?.length>10){
        errors.mobile_Number = 'Mobile number Must be 10 digit.';
      }
      
    } 
    if (this.state.mobile_Number && !mobileRegex.test(this.state.mobile_Number)) errors.mobile_Number = 'Family Member Mobile number is Invailid';
    return errors;
  };

  render() {
    const { errors, loadingList } = this.state;


    return loadingList? (
      <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
          <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      </div>
    ) :(
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Family Details
            <span
            style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
            *
          </span>
            </h5>
          </div>
          <div>
            <button type="button" className="btn btn-primary" 
            onClick={()=>{ this.setState({ add_family_member:true }) }} >
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
              Add
            </button>
            {this.state.add_family_member && (
              <div className="modal show" 
              style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }} >
                <div className="modal-dialog modal-xl">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalgridLabel">Family Details</h5>
                      <button type="button" disabled={this.state.loadingSubmit} className="btn-close" onClick={()=>{
                        this.setState({
                          employee_family_id: '',
                          family_Member_Name: '',
                          relation: 'No',
                          emergency_Contact_Person: 'Brother',
                          is_Dependend: 'No',
                          date_Of_Birth: '',
                          gender: 'Male',
                          mobile_Number: '',
                          add_family_member:false,
                        })
                      }} ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                      <div className="container mt-2">
                        <form onSubmit={this.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label htmlFor="family_Member_Name" className="form-label">Family Member Name:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              <input
                                type="text"
                                id="family_Member_Name"
                                name="family_Member_Name"
                                value={this.state.family_Member_Name}
                                onChange={this.handleInputChange}
                                className={`form-control ${errors.family_Member_Name ? 'is-invalid' : ''}`}
                                placeholder="Enter Family Member Name"
                              />
                              {errors.family_Member_Name && <div className="invalid-feedback">{errors.family_Member_Name}</div>}
                            </div>

                            <div className="col-md-6 mb-3">
                              <div>
                                <label htmlFor="relation" className="form-label">Relation:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              </div>
                              <Select
                                id="emergency_Contact_Person"
                                name="emergency_Contact_Person"
                                className={`${errors.emergency_Contact_Person ? 'is-invalid' : ''}`}
                                value={emergencyContactPerson.find(option => option.value === this.state.emergency_Contact_Person)}
                                onChange={(selectedOption) => this.handleSelectChange('emergency_Contact_Person', selectedOption)}
                                options={emergencyContactPerson}
                                placeholder="Select Relation"
                              />
                              {errors.emergency_Contact_Person && <div className="text-danger">{errors.emergency_Contact_Person}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label htmlFor="dateOfBirth" className="form-label">Date Of Birth:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              <input
                                type="date"
                                id="date_Of_Birth"
                                name="date_Of_Birth"
                                value={this.state.date_Of_Birth}
                                onChange={this.handleInputChange}
                                className={`form-control ${errors.date_Of_Birth ? 'is-invalid' : ''}`}
                                placeholder="Enter Date Of Birth"
                                pattern="\d{4}-\d{2}-\d{2}"
                              />
                              {errors.date_Of_Birth && <div className="invalid-feedback">{errors.date_Of_Birth}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label htmlFor="gender" className="form-label"> Gender:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              <Select
                                id="gender"
                                name="gender"
                                value={genderOptions.find(option => option.value === this.state.gender)}
                                onChange={(selectedOption) => this.handleSelectChange('gender', selectedOption)}
                                options={genderOptions}
                                placeholder="Select your Gender"
                              />
                              {errors.gender && <div className="text-danger">{errors.gender}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label htmlFor="mobile_Number" className="form-label">Mobile Number:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              <input
                                type="number"
                                id="mobile_Number"
                                name="mobile_Number"
                                value={this.state.mobile_Number}
                                onChange={this.handleInputChange}
                                className={`form-control ${errors.mobile_Number ? 'is-invalid' : ''}`}
                                placeholder="Enter Mobile Number"
                              />
                              {errors.mobile_Number && <div className="invalid-feedback">{errors.mobile_Number}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                              <div>
                                <label htmlFor="is_Dependend" className="form-label">Dependent:<span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span></label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="dependentYes"
                                  name="is_Dependend"
                                  value="Yes"
                                  checked={this.state.is_Dependend === 'Yes'}
                                  onChange={() => this.handleRadioChange('is_Dependend', 'Yes')}
                                  className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                                />
                                <label htmlFor="dependentYes" className="form-check-label">Yes</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="dependentNo"
                                  name="is_Dependend"
                                  value="No"
                                  checked={this.state.is_Dependend === 'No'}
                                  onChange={() => this.handleRadioChange('is_Dependend', 'No')}
                                  className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                                />
                                <label htmlFor="dependentNo" className="form-check-label">No</label>
                              </div>
                              {errors.is_Dependend && <div className="text-danger">{errors.is_Dependend}</div>}
                            </div>
                          </div>
                          <div className="d-flex justify-content-end">
                          {!this.state.loadingSubmit?
                            <button type="submit" className={`btn btn-${this.state.employee_family_id? "primary":"success"} btn-label waves-effect right waves-light`}>
                              <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> {this.state.employee_family_id? "Update" :"Save"} </button>:
                              <button className={`btn btn-${this.state.employee_family_id? "primary":"success"} btn-load`}>
                            <span className="d-flex align-items-center">
                                <span className="spinner-border flex-shrink-0" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </span>
                                <span className="flex-grow-1 ms-2">
                                    {this.state.employee_family_id? "Updating..." :"Saving..."}
                                </span>
                            </span>
                          </button>
                          }
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            )}
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Member Name</th>
                <th>Relation</th>
                <th>Date Of Birth</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>Dependent</th>
                <th className="text-center">Action</th>

              </tr>
            </thead>
            {
                this.state.rows?.length === 0?
                <tbody>
                    <tr>
                        <td colSpan={9}>
                            <NoRecords/>
                        </td>
                    </tr>
                </tbody>:
                <tbody>
                    {this.state.rows.map((row) => {
                    return (
                        <tr key={row.employee_family_id}>
                        <td>{row.family_member_name}</td>
                        <td>{row.family_member_relation}</td>
                        <td>{formatDate(row.family_member_dob)}</td>
                        <td>{row.family_member_gender}</td>
                        <td>{row.family_member_contact_number}</td>
                        <td>{row.family_member_dependent}</td>
                        <td className="d-flex justify-content-around">
                          <button
                           onClick={() =>
                            this.handleEdit(row)
                          }
                            className="btn-icon btn btn-sm btn-outline-primary">
                            <i className="ri-edit-box-line"></i>
                          </button>
                            <button
                            onClick={() =>
                                this.handleDelete(row.employee_family_id)
                            }
                            className="btn-icon btn btn-sm btn-outline-danger"
                            >
                            {" "}
                            <i className="ri-delete-bin-line"></i>{" "}
                            </button>
                        </td>
                        </tr>
                    );
                    })}
              </tbody>
            }
            
            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={7}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </div>

    );
  }
}

export default withRouter(FamilyDetails);
